var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { flowsApi } from 'apis/flows';
import { uploadsApi } from 'apis/uploads';
import { getAsyncStatusFromRtkQueryStates } from 'utils/apis/axios';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import { FileUsagePage } from '../../components/fileUsagePage/fileUsagePage';
export const SettingsAudioAnnouncement = () => {
    var _a;
    const { id } = useAppPathParams('/settings/audio/announcement/:id');
    const [getAnnouncementUsage, _b] = flowsApi.useLazyReadFlowsAnnouncementUsageQuery(), { data } = _b, rtkQueryState = __rest(_b, ["data"]);
    const asyncStatus = getAsyncStatusFromRtkQueryStates(rtkQueryState);
    useEffect(() => {
        getAnnouncementUsage({ id });
    }, [getAnnouncementUsage, id]);
    const { data: announcementData } = uploadsApi.useReadAnnouncementsQuery();
    const announcementList = announcementData === null || announcementData === void 0 ? void 0 : announcementData.data.uploads;
    const announcement = announcementList === null || announcementList === void 0 ? void 0 : announcementList.find(({ url }) => url.indexOf(id) >= 0);
    return (_jsx(FileUsagePage, { type: "announcement", usage: ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.flows) || [], file: announcement, asyncStatus: asyncStatus }));
};
